import { advancedReducer } from './services/advanced-programming.service';

export const ADVANCED_PROGRAMMING_REDUCERS: any = {
  advancedProgramming: advancedReducer
};



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/advanced.stores.ts